import request from './request'
// 活动信息 登录
export const getActivityInfo = (params: any) =>
  request({
    url: '/carbon-promotion/private/user/activity/rebate/homepage',
    method: 'get',
    params,
  })
// 活动信息 未登录
export const getActivityInfoWithoutAuth = (params: any) =>
  request({
    url: '/carbon-promotion/public/activity/rebate/homepage',
    method: 'get',
    params,
  })
// 可用金额
export const getAvailableAmount = (params: any) =>
  request({
    url: '/carbon-auth/public/activity/availableAmount',
    method: 'get',
    params,
  })
// 充值活动
export const getRechargeDisplay = (params: any) =>
  request({
    url: '/carbon-auth/public/activity/rechargeDisplay',
    method: 'get',
    params,
  })
// 分类列表
export const getCategoryList = (params: any) =>
  request({
    url: '/carbon-auth/public/activity/categoryList',
    method: 'get',
    params,
  })
// 房间列表
export const getRoomList = (params: any) =>
  request({
    url: '/carbon-auth/public/activity/roomList',
    method: 'get',
    params,
  })
// 历史列表
export const getRebateHistoryList = (params: any) =>
  request({
    url: '/carbon-promotion/private/user/activity/rebate/history',
    method: 'get',
    params,
  })
// 获取排除游戏列表
export const getExcludeGameList = (params: any) =>
  request({
    url: '/carbon-promotion/public/activity/rebate/exclude',
    method: 'get',
    params,
  })
